const { detect } = require('detect-browser')
const browser = detect()

const showWarning = () => {
    switch (browser && browser.name) {
        case 'chrome':
        case 'safari':
        case 'ios':
        return false
        default:
        return true
    }
}

export default showWarning;